"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isString = isString, exports.createCallable = createCallable, exports.invokeArrayQuery = invokeArrayQuery, exports.wrapDisplayName = wrapDisplayName, exports.getChanges = getChanges, Object.defineProperty(exports, "getEventsFromInput", {
  enumerable: !0,
  get: function get() {
    return _events.getEventsFromInput;
  }
});

var _filter2 = _interopRequireDefault(require("lodash/filter")),
    _some2 = _interopRequireDefault(require("lodash/some")),
    _isEqual2 = _interopRequireDefault(require("lodash/isEqual")),
    _constant2 = _interopRequireDefault(require("lodash/constant")),
    _events = require("./events");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isString(varToCheck) {
  return "string" == typeof varToCheck || varToCheck instanceof String;
}

function createCallable(f) {
  return "function" == typeof f ? f : (0, _constant2["default"])(f);
}

function invokeArrayQuery(f, props) {
  var result = createCallable(f)(props);
  return Array.isArray(result) ? result : result ? [result] : null;
}

function getDisplayName(Component) {
  return "string" == typeof Component ? Component : Component ? Component.displayName || Component.name || "Component" : void 0;
}

function wrapDisplayName(BaseComponent, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(BaseComponent), ")");
}

function getChanges() {
  var data = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [],
      prevData = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
      result = {};
  return result.added = (0, _filter2["default"])(data, function (d) {
    return !(0, _some2["default"])(prevData, function (p) {
      return (0, _isEqual2["default"])(d, p);
    });
  }), result.removed = (0, _filter2["default"])(prevData, function (p) {
    return !(0, _some2["default"])(data, function (d) {
      return (0, _isEqual2["default"])(p, d);
    });
  }), result;
}